<template lang="pug">
    .__page-list-event-layout
        catalog-list(
        :sort="sort",
        :items="items",
        :doubler="doubler",
        :title="title"
        )
            template(v-if="$slots.default", slot="prefix")
                slot
            catalog-sort(slot="before", :items="sortList")
</template>

<script>
    import {
        List as CatalogList,
        Sort as CatalogSort
    } from 'elysium-common/components/parts/catalog/list';

    let eventsDoubler = () => false;

    export default {
        components: {
            CatalogList,
            CatalogSort
        },
        computed: {
            sortList() {
                return this.sort.map(item => {
                    let {text, value, active} = item;
                    let to = {
                        ...this.$route,
                        query: {
                            ...this.$route.query
                        }
                    };
                    to.query[this.sortField] = value;
                    return {text, to, active};
                });
            }
        },
        props: {
            title: String,
            sortField: {
                type: String,
                default: 'sort'
            },
            sort: Array,
            limitField: String,
            limits: Array,
            limit: Number,
            items: Array,
            doubler: {
                type: Function,
                default: eventsDoubler
            }
        }
    }
</script>



// WEBPACK FOOTER //
// EventList.vue?d46d8cfc